import { Observable } from 'rxjs';
import { SOURCE_IDS } from '../common-review-card/review-types';
export type ReviewSourceInfoMap = { [sourceId: string]: ReviewSourceInfo };

export interface ReviewSourceInfo {
  sourceId: string;
  sourceName: string;
  sourceIconUrl: string;
  listingName: string;
  leaveReviewUrl?: string;
}

export interface ReviewSources {
  primarySourceIds: string[];
  otherSourceIds: string[];
  sourceInfo?: ReviewSourceInfoMap;
}

export enum PRIMARY_SOURCE_IDS {
  GOOGLE_MAPS = SOURCE_IDS.GOOGLE_MAPS,
  FACEBOOK = SOURCE_IDS.FACEBOOK,
  MY_LISTING = SOURCE_IDS.MY_LISTING,
}

export enum RESTRICTED_DISPLAY_SOURCES {
  YELP = SOURCE_IDS.YELP,
  HOTELS_DOT_COM = SOURCE_IDS.HOTELS_DOT_COM,
  BOOKING = SOURCE_IDS.BOOKING,
  TRIPADVISOR = SOURCE_IDS.TRIPADVISOR,
}

export const defaultInfoMap: ReviewSourceInfoMap = {
  '10010': {
    sourceName: 'Google',
    sourceId: '10010',
    sourceIconUrl: '//www.cdnstyles.com/static/images/icon50/sourceId-10010.png',
    listingName: 'Google',
  },
  '10050': {
    sourceName: 'Facebook',
    sourceId: '10050',
    sourceIconUrl: '//www.cdnstyles.com/static/images/icon50/sourceId-10050.png',
    listingName: 'Facebook',
  },
};

export interface SourceSelectionDependencies {
  reviewSources$: Observable<ReviewSources>;
  reviewSourcesWithURLs$: Observable<ReviewSources>;
  reviewSourceInfoMap$: Observable<ReviewSourceInfoMap>;
  showMyListing$: Observable<boolean>;
  requestSources$: Observable<{ sourceId: string; name: string; url: string }[]>; //sources with valid review request urls
}

export interface SourceSelectionModalData {
  headerTranslationKey: string;
  preselectedSources: string[];
  maxSelections: number;
  idsOverrideForSelection?: string[];
}

export const MyListingSourceRenderImplemented = false;
